import { Command, CommandEmpty, CommandGroup, CommandItem, CommandList } from '@/shared/components/ui/command'
import { CHAT_COPY, type ChatMember } from '@/entities/chat'

export function MentionPopover({
  members,
  query,
  onSelect,
}: {
  members: ChatMember[]
  query: string
  onSelect: (member: ChatMember) => void
}) {
  const matches = members.filter((member) => member.name.toLowerCase().includes(query.toLowerCase()))

  return (
    <div className="absolute bottom-full left-3 z-20 mb-1 w-64 overflow-hidden rounded-md border border-line bg-surface shadow-[var(--shadow-md)]">
      <Command>
        <CommandList className="max-h-[220px]">
          <CommandEmpty className="px-3 py-4 text-[12.5px] text-ink-3">
            {CHAT_COPY.mentionPickerEmpty}
          </CommandEmpty>
          <CommandGroup>
            {matches.map((member) => (
              <CommandItem
                key={member.userId ?? member.name}
                value={member.name}
                onSelect={() => onSelect(member)}
              >
                {member.name}
              </CommandItem>
            ))}
          </CommandGroup>
        </CommandList>
      </Command>
    </div>
  )
}
